__turbopack_context__.v({
  "author": "instructor-response-module-scss-module__uwpYAa__author",
  "author-content": "instructor-response-module-scss-module__uwpYAa__author-content",
  "author-description": "instructor-response-module-scss-module__uwpYAa__author-description",
  "body": "instructor-response-module-scss-module__uwpYAa__body",
  "comment": "instructor-response-module-scss-module__uwpYAa__comment",
  "dot": "instructor-response-module-scss-module__uwpYAa__dot",
  "name": "instructor-response-module-scss-module__uwpYAa__name",
  "response": "instructor-response-module-scss-module__uwpYAa__response",
});
